<template>
  <div class="lead-page-wrapper">
    <!-- Header Section -->
    <v-container fluid class="header-section text-xs-center pt-5">
      <h1 class="display-2 font-weight-bold mb-3 primary--text mt-5 pt-5">{{ $t('calcule_puissance_ficale.title[0]') }} <span class="title-text-shadow">{{ $t('calcule_puissance_ficale.title[1]') }}</span></h1>
      <p class="subheading grey--text text--darken-1 mx-auto">
        {{ $t('calcule_puissance_ficale.subheading') }}
      </p>
    </v-container>

    <!-- Main Content Card -->
    <v-container class="margin-top">
      <CVFiscalForm ref="form"/>
    </v-container>
  </div>
</template>

<script>
import CVFiscalForm from './CVFiscalForm.vue'; //Importation du formulaire de lead

export default {
  name: 'CVFiscalPage',
  components: {
    CVFiscalForm
  }
}
</script>

<style scoped>
.lead-page-wrapper {
  background: linear-gradient(180deg, #ffa50992 0%, #e0f7fa 30%, #ffffff 40%, #ffffff 100%);
  min-height: 100vh;
  margin-top:3%;
  font-family: 'Roboto', sans-serif; /* Ensure clean font */
}

/* Header Text Color Override if Primary isn't dark enough */
.primary--text {
  color: #2B2B2B !important; /* Teal Darken 4 for header */
}
.margin-top {
  margin-top: -2%;
}
.title-text-shadow {
  color: #ffa409;
  text-shadow: 0 0 2px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 1px 2px rgba(0, 0, 0, .3), 0 3px 9px rgba(0, 0, 0, .1);
}
</style>
